<div class="c-multievents">
  <div
    class="c-multievents__background"
    theming
    themingGroup="portal"
    themingAsset="multievents-background">
    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="c-container">
      <div class="c-multievents__title">
        <span class="text title">{{ 'home.nav.views.events' | translate }}</span>

        <div class="c-multievents__subtitle">
          <span class="text subtitle">{{ 'home.live-ops.multievents.title' | translate }}</span>
          <span class="text subtitle">{{ 'home.live-ops.multievents.subtitle' | translate }}</span>
        </div>
      </div>

      <div
        invertMouseScroll
        id="multievents-scroll-container"
        class="c-multievents__container">
        @if (limitedTimeEvents()?.length && !allEventsAreHidden()) {
          <div class="c-multievents__events">
            @for (event of limitedTimeEvents(); track event; let i = $index) {
              @if (!event.hidden) {
                <div
                  class="c-multievents__events_card"
                  theming
                  themingGroup="portal"
                  themingAsset="multievents-box">
                  <div class="c-multievents__events_card_absolute">
                    @if (event.type === LimitedTimeEventType.Tournament) {
                      <span class="text event-title">{{
                        'home.live-ops.multievents.tournament' | translate | uppercase
                      }}</span>
                    } @else if (
                      event.type === LimitedTimeEventType.GameChallenges ||
                      event.type === LimitedTimeEventType.DailyChallenge
                    ) {
                      <span class="text event-title">{{
                        'home.live-ops.multievents.challenge' | translate | uppercase
                      }}</span>
                    } @else {
                      <span class="text event-title">{{
                        'home.live-ops.multievents.promo' | translate | uppercase
                      }}</span>
                    }
                    <div
                      avoidMulticlick
                      class="c-multievents__events_image"
                      theming
                      [themingGroup]="LimitedTimeEventType[event.type]"
                      themingAsset="logo"
                      [themingOverride]="event?.assets"
                      (safeClick)="openLimitedTimeEvent(event)">
                      @if (
                        gameChallengesToRedeemById[i].eventId === event.eventId && gameChallengesToRedeemById[i].pending
                      ) {
                        <slotcom-badge [value]="gameChallengesToRedeemById[i].pending"></slotcom-badge>
                      }
                    </div>
                    @if (event.type === LimitedTimeEventType.Tournament && event.liveOpsStatus.challengeStatus.gameId) {
                      <span
                        class="text event-text"
                        [innerHTML]="
                          event.multieventText[this.lang]
                            ? event.multieventText[this.lang]
                            : ('home.live-ops.multievents.default-events-texts.' +
                                this.limitedTimeEventNames[i] +
                                '-specific'
                              | translate
                                : {
                                    x: event.liveOpsStatus.challengeStatus.gameId | gameName | uppercase
                                  })
                        "></span>
                    } @else {
                      <span
                        class="text event-text"
                        [innerHTML]="
                          event.multieventText[this.lang]
                            ? event.multieventText[this.lang]
                            : ('home.live-ops.multievents.default-events-texts.' + this.limitedTimeEventNames[i]
                              | translate)
                        "></span>
                    }
                    @if (event.current !== event.total || gameChallengesToRedeemById[i].pending !== 0) {
                      <slotcom-button
                        class="c-button--pink"
                        (safeClick)="openLimitedTimeEvent(event)"
                        audioType="functionality">
                        {{ 'home.buttons.participate' | translate | uppercase }}
                      </slotcom-button>
                    } @else {
                      <slotcom-box [classes]="['multieventsCompleted']">
                        <span class="text completed">{{
                          'home.live-ops.multievents.completed' | translate | uppercase
                        }}</span>
                      </slotcom-box>
                      <div class="e-checkIcon"></div>
                    }
                    <ng-template #completed>
                      <slotcom-box [classes]="['multieventsCompleted']">
                        <span class="text completed">{{
                          'home.live-ops.multievents.completed' | translate | uppercase
                        }}</span>
                      </slotcom-box>
                      <div class="e-checkIcon"></div>
                    </ng-template>
                    <slotcom-animated-timer
                      [showInDays]="true"
                      [endDate]="event.endDate"
                      (expired)="onExpiredLimitedTimeEvent(event)"></slotcom-animated-timer>
                  </div>
                </div>
              }
            }
          </div>
          @if (showArrows()) {
            <span
              moveWithArrows
              direction="left"
              scrollContainer="multievents-scroll-container"
              class="arrows left-arrow"></span>
            <span
              moveWithArrows
              direction="right"
              scrollContainer="multievents-scroll-container"
              class="arrows right-arrow"></span>
          }
        } @else {
          <div class="c-noEvents__background"></div>
          <slotcom-tooltip-bubble
            id="tooltip-bubble-1"
            [classes]="['c-tooltipBubble--multievents']"
            arrowPosition="left"
            arrowPercentPosition="40">
            {{ 'home.live-ops.multievents.no-events' | translate }}
          </slotcom-tooltip-bubble>
        }
      </div>
    </div>
  </div>
</div>
